import { Box, HStack, Text, VStack } from '@chakra-ui/react'
import { ButtonLink } from '../navbar/ButtonLink';
import { WorkflowTextService } from '@/shared/WorkflowTextService';

export const EmailTemplateBox = (props: {
  templateId: string
}) => {

  return (
    <Box w='lg' borderWidth={{ base: '0', md: '1px' }} p={{ base: '0', md: '2' }} borderRadius="md">
      <HStack justify='space-between' px='2' spacing='4'>
        <VStack align='start' spacing='0'>
          <Text fontWeight={600}>{props.templateId}</Text>
          <Text color='fg.subtle'>{WorkflowTextService.getTemplateDescription(props.templateId)}</Text>
        </VStack>
        <ButtonLink to={`/admin/email/${props.templateId}`}>Edit</ButtonLink>
      </HStack>
    </Box>
  );
}